'use client';

import classNames from 'classnames';

// Инлайн, а не через спрайт: у иконки смешанная покраска (ellipse — fill,
// path — stroke), а спрайт-loader вырезает fill/stroke и красит всё одним
// классом. currentColor задаётся через text-* на обёртке.
export default function IconMessage({
  className = 'w-8 h-8 text-white'
}: {
  className?: string;
}) {
  return (
    <span className={classNames('block', className)}>
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full block"
      >
        <ellipse
          cx="10.3438"
          cy="16.0002"
          rx="1.5"
          ry="1.50707"
          fill="currentColor"
        />
        <ellipse
          cx="16.2188"
          cy="16.0002"
          rx="1.5"
          ry="1.50707"
          fill="currentColor"
        />
        <ellipse
          cx="21.6562"
          cy="16.0002"
          rx="1.5"
          ry="1.50707"
          fill="currentColor"
        />
        <path
          d="M14 24C17.9331 24 20.1944 24 22.9994 24C25.7608 24 28 21.7614 28 19V13C28 10.2386 25.7614 8 23 8H9C6.23858 8 4 10.2386 4 13V19.2C4 21.851 6.14903 24 8.8 24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M8.80078 24V25.9697C8.80078 26.7993 9.75266 27.2681 10.4103 26.7625L14.0032 24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
